import axios from 'axios'

import env from 'env'

import { extractResponseData } from '../utils'

const agentProfileApiInstance = axios.create({
  baseURL: env.AGENT_PROFILE_API_BASE_URL,
})

agentProfileApiInstance.interceptors.response.use(extractResponseData)

export { agentProfileApiInstance }

export default agentProfileApiInstance
